var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluentAddCircle32Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.634 11.866 1.5 8 1.5C4.134 1.5 1 4.634 1 8.5C1 12.366 4.134 15.5 8 15.5ZM7.5 6C7.5 5.86739 7.55268 5.74021 7.64645 5.64645C7.74021 5.55268 7.86739 5.5 8 5.5C8.13261 5.5 8.25979 5.55268 8.35355 5.64645C8.44732 5.74021 8.5 5.86739 8.5 6V8H10.5C10.6326 8 10.7598 8.05268 10.8536 8.14645C10.9473 8.24021 11 8.36739 11 8.5C11 8.63261 10.9473 8.75979 10.8536 8.85355C10.7598 8.94732 10.6326 9 10.5 9H8.5V11C8.5 11.1326 8.44732 11.2598 8.35355 11.3536C8.25979 11.4473 8.13261 11.5 8 11.5C7.86739 11.5 7.74021 11.4473 7.64645 11.3536C7.55268 11.2598 7.5 11.1326 7.5 11V9H5.5C5.36739 9 5.24021 8.94732 5.14645 8.85355C5.05268 8.75979 5 8.63261 5 8.5C5 8.36739 5.05268 8.24021 5.14645 8.14645C5.24021 8.05268 5.36739 8 5.5 8H7.5V6Z",
    fill: "#3E7EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentAddCircle32Filled);
export default __webpack_public_path__ + "static/media/fluent_add-circle-32-filled.14f4f5a7276332364706e32619c3c327.svg";
export { ForwardRef as ReactComponent };